var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 383,
    viewBox: "0 0 501 383",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 367.291L0 382L14.7092 382L14.7092 367.291L-6.4296e-07 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 352.582L0 367.291L14.7092 367.291L14.7092 352.582L-6.4296e-07 352.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 337.88L0 352.589L14.7092 352.589L14.7092 337.88L-6.4296e-07 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 323.17L0 337.879L14.7092 337.879L14.7092 323.17L-6.4296e-07 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 308.468L0 323.177L14.7092 323.177L14.7092 308.468L-6.4296e-07 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 293.759L0 308.468L14.7092 308.468L14.7092 293.759L-6.4296e-07 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 279.057L0 293.766L14.7092 293.766L14.7092 279.057L-6.4296e-07 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.42961e-07 264.347L0 279.057L14.7092 279.057L14.7092 264.347L-6.42961e-07 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 249.645L0 264.354L14.7092 264.354L14.7092 249.645L-6.4296e-07 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.42961e-07 234.936L0 249.646L14.7092 249.646L14.7092 234.936L-6.42961e-07 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 220.234L0 234.943L14.7092 234.943L14.7092 220.234L-6.4296e-07 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.42961e-07 205.525L0 220.234L14.7092 220.234L14.7092 205.525L-6.42961e-07 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 190.823L0 205.532L14.7092 205.532L14.7092 190.823L-6.4296e-07 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 176.114L0 190.823L14.7092 190.823L14.7092 176.114L-6.4296e-07 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 161.411L0 176.121L14.7092 176.121L14.7092 161.411L-6.4296e-07 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 146.702L0 161.411L14.7092 161.411L14.7092 146.702L-6.4296e-07 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 132L0 146.709L14.7092 146.709L14.7092 132L-6.4296e-07 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 117.291L0 132L14.7092 132L14.7092 117.291L-6.4296e-07 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.42961e-07 102.582L0 117.291L14.7092 117.291L14.7092 102.582L-6.42961e-07 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 87.8797L0 102.589L14.7092 102.589L14.7092 87.8797L-6.4296e-07 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.42961e-07 73.1702L0 87.8794L14.7092 87.8794L14.7092 73.1702L-6.42961e-07 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 58.468L0 73.1772L14.7092 73.1772L14.7092 58.468L-6.4296e-07 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.42961e-07 43.759L0 58.4683L14.7092 58.4683L14.7092 43.759L-6.42961e-07 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 29.0569L0 43.7661L14.7092 43.7661L14.7092 29.0569L-6.4296e-07 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.42961e-07 14.3474L0 29.0566L14.7092 29.0566L14.7092 14.3474L-6.42961e-07 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.4296e-07 -0.354722L0 14.3545L14.7092 14.3545L14.7092 -0.354723L-6.4296e-07 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 367.291L14.7092 382L29.4184 382L29.4184 367.291L14.7092 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 352.582L14.7092 367.291L29.4184 367.291L29.4184 352.582L14.7092 352.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 337.88L14.7092 352.589L29.4184 352.589L29.4184 337.88L14.7092 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 323.17L14.7092 337.879L29.4184 337.879L29.4184 323.17L14.7092 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 308.468L14.7092 323.177L29.4184 323.177L29.4184 308.468L14.7092 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 293.759L14.7092 308.468L29.4184 308.468L29.4184 293.759L14.7092 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 279.057L14.7092 293.766L29.4184 293.766L29.4184 279.057L14.7092 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 264.347L14.7092 279.057L29.4184 279.057L29.4184 264.347L14.7092 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 249.645L14.7092 264.354L29.4184 264.354L29.4184 249.645L14.7092 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 234.936L14.7092 249.646L29.4184 249.646L29.4184 234.936L14.7092 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 220.234L14.7092 234.943L29.4184 234.943L29.4184 220.234L14.7092 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 205.525L14.7092 220.234L29.4184 220.234L29.4184 205.525L14.7092 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 190.823L14.7092 205.532L29.4184 205.532L29.4184 190.823L14.7092 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 176.114L14.7092 190.823L29.4184 190.823L29.4184 176.114L14.7092 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 161.411L14.7092 176.121L29.4184 176.121L29.4184 161.411L14.7092 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 146.702L14.7092 161.411L29.4184 161.411L29.4184 146.702L14.7092 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 132L14.7092 146.709L29.4184 146.709L29.4184 132L14.7092 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 117.291L14.7092 132L29.4184 132L29.4184 117.291L14.7092 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 102.582L14.7092 117.291L29.4184 117.291L29.4184 102.582L14.7092 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 87.8797L14.7092 102.589L29.4184 102.589L29.4184 87.8797L14.7092 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 73.1702L14.7092 87.8794L29.4184 87.8794L29.4184 73.1702L14.7092 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 58.468L14.7092 73.1772L29.4184 73.1772L29.4184 58.468L14.7092 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 43.759L14.7092 58.4683L29.4184 58.4683L29.4184 43.759L14.7092 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 29.0569L14.7092 43.7661L29.4184 43.7661L29.4184 29.0569L14.7092 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 14.3474L14.7092 29.0566L29.4184 29.0566L29.4184 14.3474L14.7092 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7092 -0.354722L14.7092 14.3545L29.4184 14.3545L29.4184 -0.354723L14.7092 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 367.291L29.4121 382L44.1213 382L44.1213 367.291L29.4121 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 352.581L29.4121 367.291L44.1213 367.291L44.1213 352.581L29.4121 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 337.88L29.4121 352.589L44.1213 352.589L44.1213 337.88L29.4121 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 323.17L29.4121 337.879L44.1213 337.879L44.1213 323.17L29.4121 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 308.468L29.4121 323.177L44.1213 323.177L44.1213 308.468L29.4121 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 293.759L29.4121 308.468L44.1213 308.468L44.1213 293.759L29.4121 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 279.057L29.4121 293.766L44.1213 293.766L44.1213 279.057L29.4121 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 264.347L29.4121 279.057L44.1213 279.057L44.1213 264.347L29.4121 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 249.645L29.4121 264.354L44.1213 264.354L44.1213 249.645L29.4121 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 234.936L29.4121 249.646L44.1213 249.646L44.1213 234.936L29.4121 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 220.234L29.4121 234.943L44.1213 234.943L44.1213 220.234L29.4121 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 205.525L29.4121 220.234L44.1213 220.234L44.1213 205.525L29.4121 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 190.823L29.4121 205.532L44.1213 205.532L44.1213 190.823L29.4121 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 176.114L29.4121 190.823L44.1213 190.823L44.1213 176.114L29.4121 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 161.411L29.4121 176.121L44.1213 176.121L44.1213 161.411L29.4121 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 146.702L29.4121 161.411L44.1213 161.411L44.1213 146.702L29.4121 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 132L29.4121 146.709L44.1213 146.709L44.1213 132L29.4121 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 117.291L29.4121 132L44.1213 132L44.1213 117.291L29.4121 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 102.582L29.4121 117.291L44.1213 117.291L44.1213 102.582L29.4121 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 87.8797L29.4121 102.589L44.1213 102.589L44.1213 87.8797L29.4121 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 73.1702L29.4121 87.8794L44.1213 87.8794L44.1213 73.1702L29.4121 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 58.468L29.4121 73.1772L44.1213 73.1772L44.1213 58.468L29.4121 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 43.759L29.4121 58.4683L44.1213 58.4683L44.1213 43.759L29.4121 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 29.0569L29.4121 43.7661L44.1213 43.7661L44.1213 29.0569L29.4121 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 14.3474L29.4121 29.0566L44.1213 29.0566L44.1213 14.3474L29.4121 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4121 -0.354722L29.4121 14.3545L44.1213 14.3545L44.1213 -0.354723L29.4121 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 367.291L44.1211 382L58.8303 382L58.8303 367.291L44.1211 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 352.581L44.1211 367.291L58.8303 367.291L58.8303 352.581L44.1211 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 337.88L44.1211 352.589L58.8303 352.589L58.8303 337.88L44.1211 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 323.17L44.1211 337.879L58.8303 337.879L58.8303 323.17L44.1211 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 308.468L44.1211 323.177L58.8303 323.177L58.8303 308.468L44.1211 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 293.759L44.1211 308.468L58.8303 308.468L58.8303 293.759L44.1211 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 279.057L44.1211 293.766L58.8303 293.766L58.8303 279.057L44.1211 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 264.347L44.1211 279.057L58.8303 279.057L58.8303 264.347L44.1211 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 249.645L44.1211 264.354L58.8303 264.354L58.8303 249.645L44.1211 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 234.936L44.1211 249.646L58.8303 249.646L58.8303 234.936L44.1211 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 220.234L44.1211 234.943L58.8303 234.943L58.8303 220.234L44.1211 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 205.525L44.1211 220.234L58.8303 220.234L58.8303 205.525L44.1211 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 190.823L44.1211 205.532L58.8303 205.532L58.8303 190.823L44.1211 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 176.114L44.1211 190.823L58.8303 190.823L58.8303 176.114L44.1211 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 161.411L44.1211 176.121L58.8303 176.121L58.8303 161.411L44.1211 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 146.702L44.1211 161.411L58.8303 161.411L58.8303 146.702L44.1211 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 132L44.1211 146.709L58.8303 146.709L58.8303 132L44.1211 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 117.291L44.1211 132L58.8303 132L58.8303 117.291L44.1211 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 102.582L44.1211 117.291L58.8303 117.291L58.8303 102.582L44.1211 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 87.8797L44.1211 102.589L58.8303 102.589L58.8303 87.8797L44.1211 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 73.1702L44.1211 87.8794L58.8303 87.8794L58.8303 73.1702L44.1211 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 58.468L44.1211 73.1772L58.8303 73.1772L58.8303 58.468L44.1211 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 43.759L44.1211 58.4683L58.8303 58.4683L58.8303 43.759L44.1211 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 29.0569L44.1211 43.7661L58.8303 43.7661L58.8303 29.0569L44.1211 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 14.3474L44.1211 29.0566L58.8303 29.0566L58.8303 14.3474L44.1211 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 -0.354722L44.1211 14.3545L58.8303 14.3545L58.8303 -0.354723L44.1211 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 367.291L58.8223 382L73.5315 382L73.5315 367.291L58.8223 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 352.582L58.8223 367.291L73.5315 367.291L73.5315 352.582L58.8223 352.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 337.88L58.8223 352.589L73.5315 352.589L73.5315 337.88L58.8223 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 323.17L58.8223 337.879L73.5315 337.879L73.5315 323.17L58.8223 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 308.468L58.8223 323.177L73.5315 323.177L73.5315 308.468L58.8223 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 293.759L58.8223 308.468L73.5315 308.468L73.5315 293.759L58.8223 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 279.057L58.8223 293.766L73.5315 293.766L73.5315 279.057L58.8223 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 264.347L58.8223 279.057L73.5315 279.057L73.5315 264.347L58.8223 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 249.645L58.8223 264.354L73.5315 264.354L73.5315 249.645L58.8223 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 234.936L58.8223 249.646L73.5315 249.646L73.5315 234.936L58.8223 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 220.234L58.8223 234.943L73.5315 234.943L73.5315 220.234L58.8223 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 205.525L58.8223 220.234L73.5315 220.234L73.5315 205.525L58.8223 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 190.823L58.8223 205.532L73.5315 205.532L73.5315 190.823L58.8223 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 176.114L58.8223 190.823L73.5315 190.823L73.5315 176.114L58.8223 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 161.411L58.8223 176.121L73.5315 176.121L73.5315 161.411L58.8223 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 146.702L58.8223 161.411L73.5315 161.411L73.5315 146.702L58.8223 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 132L58.8223 146.709L73.5315 146.709L73.5315 132L58.8223 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 117.291L58.8223 132L73.5315 132L73.5315 117.291L58.8223 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 102.582L58.8223 117.291L73.5315 117.291L73.5315 102.582L58.8223 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 87.8797L58.8223 102.589L73.5315 102.589L73.5315 87.8797L58.8223 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 73.1702L58.8223 87.8794L73.5315 87.8794L73.5315 73.1702L58.8223 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 58.468L58.8223 73.1772L73.5315 73.1772L73.5315 58.468L58.8223 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 43.759L58.8223 58.4683L73.5315 58.4683L73.5315 43.759L58.8223 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 29.0569L58.8223 43.7661L73.5315 43.7661L73.5315 29.0569L58.8223 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 14.3474L58.8223 29.0566L73.5315 29.0566L73.5315 14.3474L58.8223 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8223 -0.354722L58.8223 14.3545L73.5315 14.3545L73.5315 -0.354723L58.8223 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 367.291L73.5312 382L88.2405 382L88.2405 367.291L73.5312 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 352.581L73.5312 367.291L88.2405 367.291L88.2405 352.581L73.5312 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 337.88L73.5312 352.589L88.2405 352.589L88.2405 337.88L73.5312 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 323.17L73.5312 337.879L88.2405 337.879L88.2405 323.17L73.5312 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 308.468L73.5312 323.177L88.2405 323.177L88.2405 308.468L73.5312 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 293.759L73.5312 308.468L88.2405 308.468L88.2405 293.759L73.5312 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 279.057L73.5312 293.766L88.2405 293.766L88.2405 279.057L73.5312 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 264.347L73.5312 279.057L88.2405 279.057L88.2405 264.347L73.5312 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 249.645L73.5312 264.354L88.2405 264.354L88.2405 249.645L73.5312 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 234.936L73.5312 249.646L88.2405 249.646L88.2405 234.936L73.5312 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 220.234L73.5312 234.943L88.2405 234.943L88.2405 220.234L73.5312 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 205.525L73.5312 220.234L88.2405 220.234L88.2405 205.525L73.5312 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 190.823L73.5312 205.532L88.2405 205.532L88.2405 190.823L73.5312 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 176.114L73.5312 190.823L88.2405 190.823L88.2405 176.114L73.5312 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 161.411L73.5312 176.121L88.2405 176.121L88.2405 161.411L73.5312 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 146.702L73.5312 161.411L88.2405 161.411L88.2405 146.702L73.5312 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 132L73.5312 146.709L88.2405 146.709L88.2405 132L73.5312 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 117.291L73.5312 132L88.2405 132L88.2405 117.291L73.5312 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 102.582L73.5312 117.291L88.2405 117.291L88.2405 102.582L73.5312 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 87.8797L73.5312 102.589L88.2405 102.589L88.2405 87.8797L73.5312 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 73.1702L73.5312 87.8794L88.2405 87.8794L88.2405 73.1702L73.5312 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 58.468L73.5312 73.1772L88.2405 73.1772L88.2405 58.468L73.5312 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 43.759L73.5312 58.4683L88.2405 58.4683L88.2405 43.759L73.5312 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 29.0569L73.5312 43.7661L88.2405 43.7661L88.2405 29.0569L73.5312 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 14.3474L73.5312 29.0566L88.2405 29.0566L88.2405 14.3474L73.5312 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 -0.354722L73.5312 14.3545L88.2405 14.3545L88.2405 -0.354723L73.5312 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 367.291L88.2344 382L102.944 382L102.944 367.291L88.2344 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 352.581L88.2344 367.291L102.944 367.291L102.944 352.581L88.2344 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 337.88L88.2344 352.589L102.944 352.589L102.944 337.88L88.2344 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 323.17L88.2344 337.879L102.944 337.879L102.944 323.17L88.2344 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 308.468L88.2344 323.177L102.944 323.177L102.944 308.468L88.2344 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 293.759L88.2344 308.468L102.944 308.468L102.944 293.759L88.2344 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 279.057L88.2344 293.766L102.944 293.766L102.944 279.057L88.2344 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 264.347L88.2344 279.057L102.944 279.057L102.944 264.347L88.2344 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 249.645L88.2344 264.354L102.944 264.354L102.944 249.645L88.2344 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 234.936L88.2344 249.646L102.944 249.646L102.944 234.936L88.2344 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 220.234L88.2344 234.943L102.944 234.943L102.944 220.234L88.2344 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 205.525L88.2344 220.234L102.944 220.234L102.944 205.525L88.2344 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 190.823L88.2344 205.532L102.944 205.532L102.944 190.823L88.2344 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 176.114L88.2344 190.823L102.944 190.823L102.944 176.114L88.2344 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 161.411L88.2344 176.121L102.944 176.121L102.944 161.411L88.2344 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 146.702L88.2344 161.411L102.944 161.411L102.944 146.702L88.2344 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 132L88.2344 146.709L102.944 146.709L102.944 132L88.2344 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 117.291L88.2344 132L102.944 132L102.944 117.291L88.2344 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 102.582L88.2344 117.291L102.944 117.291L102.944 102.582L88.2344 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 87.8797L88.2344 102.589L102.944 102.589L102.944 87.8797L88.2344 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 73.1702L88.2344 87.8794L102.944 87.8794L102.944 73.1702L88.2344 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 58.468L88.2344 73.1772L102.944 73.1772L102.944 58.468L88.2344 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 43.759L88.2344 58.4683L102.944 58.4683L102.944 43.759L88.2344 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 29.0569L88.2344 43.7661L102.944 43.7661L102.944 29.0569L88.2344 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 14.3474L88.2344 29.0566L102.944 29.0566L102.944 14.3474L88.2344 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2344 -0.354722L88.2344 14.3545L102.944 14.3545L102.944 -0.354723L88.2344 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 367.291L102.943 382L117.652 382L117.652 367.291L102.943 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 352.582L102.943 367.291L117.652 367.291L117.652 352.582L102.943 352.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 337.88L102.943 352.589L117.652 352.589L117.652 337.88L102.943 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 323.17L102.943 337.879L117.652 337.879L117.652 323.17L102.943 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 308.468L102.943 323.177L117.652 323.177L117.652 308.468L102.943 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 293.759L102.943 308.468L117.652 308.468L117.652 293.759L102.943 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 279.057L102.943 293.766L117.652 293.766L117.652 279.057L102.943 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 264.347L102.943 279.057L117.652 279.057L117.652 264.347L102.943 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 249.645L102.943 264.354L117.652 264.354L117.652 249.645L102.943 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 234.936L102.943 249.646L117.652 249.646L117.652 234.936L102.943 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 220.234L102.943 234.943L117.652 234.943L117.652 220.234L102.943 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 205.525L102.943 220.234L117.652 220.234L117.652 205.525L102.943 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 190.823L102.943 205.532L117.652 205.532L117.652 190.823L102.943 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 176.114L102.943 190.823L117.652 190.823L117.652 176.114L102.943 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 161.411L102.943 176.121L117.652 176.121L117.652 161.411L102.943 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 146.702L102.943 161.411L117.652 161.411L117.652 146.702L102.943 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 132L102.943 146.709L117.652 146.709L117.652 132L102.943 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 117.291L102.943 132L117.652 132L117.652 117.291L102.943 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 102.582L102.943 117.291L117.652 117.291L117.652 102.582L102.943 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 87.8797L102.943 102.589L117.652 102.589L117.652 87.8797L102.943 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 73.1702L102.943 87.8794L117.652 87.8794L117.652 73.1702L102.943 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 58.468L102.943 73.1772L117.652 73.1772L117.652 58.468L102.943 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 43.759L102.943 58.4683L117.652 58.4683L117.652 43.759L102.943 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 29.0569L102.943 43.7661L117.652 43.7661L117.652 29.0569L102.943 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 14.3474L102.943 29.0566L117.652 29.0566L117.652 14.3474L102.943 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 -0.354722L102.943 14.3545L117.652 14.3545L117.652 -0.354723L102.943 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 367.291L117.645 382L132.354 382L132.354 367.291L117.645 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 352.581L117.645 367.291L132.354 367.291L132.354 352.581L117.645 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 337.88L117.645 352.589L132.354 352.589L132.354 337.88L117.645 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 323.17L117.645 337.879L132.354 337.879L132.354 323.17L117.645 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 308.468L117.645 323.177L132.354 323.177L132.354 308.468L117.645 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 293.759L117.645 308.468L132.354 308.468L132.354 293.759L117.645 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 279.057L117.645 293.766L132.354 293.766L132.354 279.057L117.645 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 264.347L117.645 279.057L132.354 279.057L132.354 264.347L117.645 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 249.645L117.645 264.354L132.354 264.354L132.354 249.645L117.645 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 234.936L117.645 249.646L132.354 249.646L132.354 234.936L117.645 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 220.234L117.645 234.943L132.354 234.943L132.354 220.234L117.645 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 205.525L117.645 220.234L132.354 220.234L132.354 205.525L117.645 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 190.823L117.645 205.532L132.354 205.532L132.354 190.823L117.645 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 176.114L117.645 190.823L132.354 190.823L132.354 176.114L117.645 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 161.411L117.645 176.121L132.354 176.121L132.354 161.411L117.645 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 146.702L117.645 161.411L132.354 161.411L132.354 146.702L117.645 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 132L117.645 146.709L132.354 146.709L132.354 132L117.645 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 117.291L117.645 132L132.354 132L132.354 117.291L117.645 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 102.582L117.645 117.291L132.354 117.291L132.354 102.582L117.645 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 87.8797L117.645 102.589L132.354 102.589L132.354 87.8797L117.645 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 73.1702L117.645 87.8794L132.354 87.8794L132.354 73.1702L117.645 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 58.468L117.645 73.1772L132.354 73.1772L132.354 58.468L117.645 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 43.759L117.645 58.4683L132.354 58.4683L132.354 43.759L117.645 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 29.0569L117.645 43.7661L132.354 43.7661L132.354 29.0569L117.645 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 14.3474L117.645 29.0566L132.354 29.0566L132.354 14.3474L117.645 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.645 -0.354722L117.645 14.3545L132.354 14.3545L132.354 -0.354723L117.645 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 367.291L132.354 382L147.063 382L147.063 367.291L132.354 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 352.581L132.354 367.291L147.063 367.291L147.063 352.581L132.354 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 337.879L132.354 352.588L147.063 352.588L147.063 337.879L132.354 337.879Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 323.17L132.354 337.879L147.063 337.879L147.063 323.17L132.354 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 308.468L132.354 323.177L147.063 323.177L147.063 308.468L132.354 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 293.759L132.354 308.468L147.063 308.468L147.063 293.759L132.354 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 279.057L132.354 293.766L147.063 293.766L147.063 279.057L132.354 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 264.347L132.354 279.057L147.063 279.057L147.063 264.347L132.354 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 249.645L132.354 264.354L147.063 264.354L147.063 249.645L132.354 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 234.936L132.354 249.646L147.063 249.646L147.063 234.936L132.354 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 220.234L132.354 234.943L147.063 234.943L147.063 220.234L132.354 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 205.525L132.354 220.234L147.063 220.234L147.063 205.525L132.354 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 190.823L132.354 205.532L147.063 205.532L147.063 190.823L132.354 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 176.114L132.354 190.823L147.063 190.823L147.063 176.114L132.354 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 161.411L132.354 176.121L147.063 176.121L147.063 161.411L132.354 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 146.702L132.354 161.411L147.063 161.411L147.063 146.702L132.354 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 132L132.354 146.709L147.063 146.709L147.063 132L132.354 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 117.291L132.354 132L147.063 132L147.063 117.291L132.354 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 102.582L132.354 117.291L147.063 117.291L147.063 102.582L132.354 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 87.8797L132.354 102.589L147.063 102.589L147.063 87.8797L132.354 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 73.1702L132.354 87.8794L147.063 87.8794L147.063 73.1702L132.354 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 58.468L132.354 73.1772L147.063 73.1772L147.063 58.468L132.354 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 43.759L132.354 58.4683L147.063 58.4683L147.063 43.759L132.354 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 29.0569L132.354 43.7661L147.063 43.7661L147.063 29.0569L132.354 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 14.3474L132.354 29.0566L147.063 29.0566L147.063 14.3474L132.354 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 -0.354722L132.354 14.3545L147.063 14.3545L147.063 -0.354723L132.354 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 367.291L147.057 382L161.766 382L161.766 367.291L147.057 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 352.582L147.057 367.291L161.766 367.291L161.766 352.582L147.057 352.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 337.88L147.057 352.589L161.766 352.589L161.766 337.88L147.057 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 323.17L147.057 337.879L161.766 337.879L161.766 323.17L147.057 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 308.468L147.057 323.177L161.766 323.177L161.766 308.468L147.057 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 293.759L147.057 308.468L161.766 308.468L161.766 293.759L147.057 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 279.057L147.057 293.766L161.766 293.766L161.766 279.057L147.057 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 264.347L147.057 279.057L161.766 279.057L161.766 264.347L147.057 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 249.645L147.057 264.354L161.766 264.354L161.766 249.645L147.057 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 234.936L147.057 249.646L161.766 249.646L161.766 234.936L147.057 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 220.234L147.057 234.943L161.766 234.943L161.766 220.234L147.057 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 205.525L147.057 220.234L161.766 220.234L161.766 205.525L147.057 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 190.823L147.057 205.532L161.766 205.532L161.766 190.823L147.057 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 176.114L147.057 190.823L161.766 190.823L161.766 176.114L147.057 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 161.411L147.057 176.121L161.766 176.121L161.766 161.411L147.057 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 146.702L147.057 161.411L161.766 161.411L161.766 146.702L147.057 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 132L147.057 146.709L161.766 146.709L161.766 132L147.057 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 117.291L147.057 132L161.766 132L161.766 117.291L147.057 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 102.582L147.057 117.291L161.766 117.291L161.766 102.582L147.057 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 87.8797L147.057 102.589L161.766 102.589L161.766 87.8797L147.057 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 73.1702L147.057 87.8794L161.766 87.8794L161.766 73.1702L147.057 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 58.468L147.057 73.1772L161.766 73.1772L161.766 58.468L147.057 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 43.759L147.057 58.4683L161.766 58.4683L161.766 43.759L147.057 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 29.0569L147.057 43.7661L161.766 43.7661L161.766 29.0569L147.057 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 14.3474L147.057 29.0566L161.766 29.0566L161.766 14.3474L147.057 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.057 -0.354722L147.057 14.3545L161.766 14.3545L161.766 -0.354723L147.057 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 367.291L161.766 382L176.475 382L176.475 367.291L161.766 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 352.582L161.766 367.291L176.475 367.291L176.475 352.582L161.766 352.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 337.88L161.766 352.589L176.475 352.589L176.475 337.88L161.766 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 323.17L161.766 337.879L176.475 337.879L176.475 323.17L161.766 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 308.468L161.766 323.177L176.475 323.177L176.475 308.468L161.766 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 293.759L161.766 308.468L176.475 308.468L176.475 293.759L161.766 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 279.057L161.766 293.766L176.475 293.766L176.475 279.057L161.766 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 264.347L161.766 279.057L176.475 279.057L176.475 264.347L161.766 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 249.645L161.766 264.354L176.475 264.354L176.475 249.645L161.766 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 234.936L161.766 249.646L176.475 249.646L176.475 234.936L161.766 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 220.234L161.766 234.943L176.475 234.943L176.475 220.234L161.766 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 205.525L161.766 220.234L176.475 220.234L176.475 205.525L161.766 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 190.823L161.766 205.532L176.475 205.532L176.475 190.823L161.766 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 176.114L161.766 190.823L176.475 190.823L176.475 176.114L161.766 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 161.411L161.766 176.121L176.475 176.121L176.475 161.411L161.766 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 146.702L161.766 161.411L176.475 161.411L176.475 146.702L161.766 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 132L161.766 146.709L176.475 146.709L176.475 132L161.766 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 117.291L161.766 132L176.475 132L176.475 117.291L161.766 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 102.582L161.766 117.291L176.475 117.291L176.475 102.582L161.766 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 87.8797L161.766 102.589L176.475 102.589L176.475 87.8797L161.766 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 73.1702L161.766 87.8794L176.475 87.8794L176.475 73.1702L161.766 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 58.468L161.766 73.1772L176.475 73.1772L176.475 58.468L161.766 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 43.759L161.766 58.4683L176.475 58.4683L176.475 43.759L161.766 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 29.0569L161.766 43.7661L176.475 43.7661L176.475 29.0569L161.766 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 14.3474L161.766 29.0566L176.475 29.0566L176.475 14.3474L161.766 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.766 -0.354722L161.766 14.3545L176.475 14.3545L176.475 -0.354723L161.766 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 367.291L176.469 382L191.178 382L191.178 367.291L176.469 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 352.581L176.469 367.291L191.178 367.291L191.178 352.581L176.469 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 337.879L176.469 352.588L191.178 352.588L191.178 337.879L176.469 337.879Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 323.17L176.469 337.879L191.178 337.879L191.178 323.17L176.469 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 308.468L176.469 323.177L191.178 323.177L191.178 308.468L176.469 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 293.759L176.469 308.468L191.178 308.468L191.178 293.759L176.469 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 279.057L176.469 293.766L191.178 293.766L191.178 279.057L176.469 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 264.347L176.469 279.057L191.178 279.057L191.178 264.347L176.469 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 249.645L176.469 264.354L191.178 264.354L191.178 249.645L176.469 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 234.936L176.469 249.646L191.178 249.646L191.178 234.936L176.469 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 220.234L176.469 234.943L191.178 234.943L191.178 220.234L176.469 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 205.525L176.469 220.234L191.178 220.234L191.178 205.525L176.469 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 190.823L176.469 205.532L191.178 205.532L191.178 190.823L176.469 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 176.114L176.469 190.823L191.178 190.823L191.178 176.114L176.469 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 161.411L176.469 176.121L191.178 176.121L191.178 161.411L176.469 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 146.702L176.469 161.411L191.178 161.411L191.178 146.702L176.469 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 132L176.469 146.709L191.178 146.709L191.178 132L176.469 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 117.291L176.469 132L191.178 132L191.178 117.291L176.469 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 102.582L176.469 117.291L191.178 117.291L191.178 102.582L176.469 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 87.8797L176.469 102.589L191.178 102.589L191.178 87.8797L176.469 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 73.1702L176.469 87.8794L191.178 87.8794L191.178 73.1702L176.469 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 58.468L176.469 73.1772L191.178 73.1772L191.178 58.468L176.469 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 43.759L176.469 58.4683L191.178 58.4683L191.178 43.759L176.469 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 29.0569L176.469 43.7661L191.178 43.7661L191.178 29.0569L176.469 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 14.3474L176.469 29.0566L191.178 29.0566L191.178 14.3474L176.469 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.469 -0.354722L176.469 14.3545L191.178 14.3545L191.178 -0.354723L176.469 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 367.291L191.178 382L205.887 382L205.887 367.291L191.178 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 352.582L191.178 367.291L205.887 367.291L205.887 352.582L191.178 352.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 337.879L191.178 352.588L205.887 352.588L205.887 337.879L191.178 337.879Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 323.17L191.178 337.879L205.887 337.879L205.887 323.17L191.178 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 308.468L191.178 323.177L205.887 323.177L205.887 308.468L191.178 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 293.759L191.178 308.468L205.887 308.468L205.887 293.759L191.178 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 279.057L191.178 293.766L205.887 293.766L205.887 279.057L191.178 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 264.347L191.178 279.057L205.887 279.057L205.887 264.347L191.178 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 249.645L191.178 264.354L205.887 264.354L205.887 249.645L191.178 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 234.936L191.178 249.646L205.887 249.646L205.887 234.936L191.178 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 220.234L191.178 234.943L205.887 234.943L205.887 220.234L191.178 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 205.525L191.178 220.234L205.887 220.234L205.887 205.525L191.178 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 190.823L191.178 205.532L205.887 205.532L205.887 190.823L191.178 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 176.114L191.178 190.823L205.887 190.823L205.887 176.114L191.178 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 161.411L191.178 176.121L205.887 176.121L205.887 161.411L191.178 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 146.702L191.178 161.411L205.887 161.411L205.887 146.702L191.178 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 132L191.178 146.709L205.887 146.709L205.887 132L191.178 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 117.291L191.178 132L205.887 132L205.887 117.291L191.178 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 102.582L191.178 117.291L205.887 117.291L205.887 102.582L191.178 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 87.8797L191.178 102.589L205.887 102.589L205.887 87.8797L191.178 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 73.1702L191.178 87.8794L205.887 87.8794L205.887 73.1702L191.178 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 58.468L191.178 73.1772L205.887 73.1772L205.887 58.468L191.178 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 43.759L191.178 58.4683L205.887 58.4683L205.887 43.759L191.178 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 29.0569L191.178 43.7661L205.887 43.7661L205.887 29.0569L191.178 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 14.3474L191.178 29.0566L205.887 29.0566L205.887 14.3474L191.178 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.178 -0.354722L191.178 14.3545L205.887 14.3545L205.887 -0.354723L191.178 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 367.291L205.879 382L220.588 382L220.588 367.291L205.879 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 352.581L205.879 367.291L220.588 367.291L220.588 352.581L205.879 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 337.88L205.879 352.589L220.588 352.589L220.588 337.88L205.879 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 323.17L205.879 337.879L220.588 337.879L220.588 323.17L205.879 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 308.468L205.879 323.177L220.588 323.177L220.588 308.468L205.879 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 293.759L205.879 308.468L220.588 308.468L220.588 293.759L205.879 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 279.057L205.879 293.766L220.588 293.766L220.588 279.057L205.879 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 264.347L205.879 279.057L220.588 279.057L220.588 264.347L205.879 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 249.645L205.879 264.354L220.588 264.354L220.588 249.645L205.879 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 234.936L205.879 249.646L220.588 249.646L220.588 234.936L205.879 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 220.234L205.879 234.943L220.588 234.943L220.588 220.234L205.879 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 205.525L205.879 220.234L220.588 220.234L220.588 205.525L205.879 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 190.823L205.879 205.532L220.588 205.532L220.588 190.823L205.879 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 176.114L205.879 190.823L220.588 190.823L220.588 176.114L205.879 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 161.411L205.879 176.121L220.588 176.121L220.588 161.411L205.879 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 146.702L205.879 161.411L220.588 161.411L220.588 146.702L205.879 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 132L205.879 146.709L220.588 146.709L220.588 132L205.879 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 117.291L205.879 132L220.588 132L220.588 117.291L205.879 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 102.582L205.879 117.291L220.588 117.291L220.588 102.582L205.879 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 87.8797L205.879 102.589L220.588 102.589L220.588 87.8797L205.879 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 73.1702L205.879 87.8794L220.588 87.8794L220.588 73.1702L205.879 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 58.468L205.879 73.1772L220.588 73.1772L220.588 58.468L205.879 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 43.759L205.879 58.4683L220.588 58.4683L220.588 43.759L205.879 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 29.0569L205.879 43.7661L220.588 43.7661L220.588 29.0569L205.879 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 14.3474L205.879 29.0566L220.588 29.0566L220.588 14.3474L205.879 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.879 -0.354722L205.879 14.3545L220.588 14.3545L220.588 -0.354723L205.879 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 367.291L220.59 382L235.299 382L235.299 367.291L220.59 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.588 352.581L220.588 367.291L235.297 367.291L235.297 352.581L220.588 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.588 337.879L220.588 352.588L235.297 352.588L235.297 337.879L220.588 337.879Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.588 323.17L220.588 337.879L235.297 337.879L235.297 323.17L220.588 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.588 308.468L220.588 323.177L235.297 323.177L235.297 308.468L220.588 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.588 293.759L220.588 308.468L235.297 308.468L235.297 293.759L220.588 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.588 279.057L220.588 293.766L235.297 293.766L235.297 279.057L220.588 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.588 264.347L220.588 279.057L235.297 279.057L235.297 264.347L220.588 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.588 249.645L220.588 264.354L235.297 264.354L235.297 249.645L220.588 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.588 234.936L220.588 249.646L235.297 249.646L235.297 234.936L220.588 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 220.234L220.59 234.943L235.299 234.943L235.299 220.234L220.59 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 205.525L220.59 220.234L235.299 220.234L235.299 205.525L220.59 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 190.823L220.59 205.532L235.299 205.532L235.299 190.823L220.59 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 176.114L220.59 190.823L235.299 190.823L235.299 176.114L220.59 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 161.411L220.59 176.121L235.299 176.121L235.299 161.411L220.59 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 146.702L220.59 161.411L235.299 161.411L235.299 146.702L220.59 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 132L220.59 146.709L235.299 146.709L235.299 132L220.59 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 117.291L220.59 132L235.299 132L235.299 117.291L220.59 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 102.582L220.59 117.291L235.299 117.291L235.299 102.582L220.59 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 87.8797L220.59 102.589L235.299 102.589L235.299 87.8797L220.59 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 73.1702L220.59 87.8794L235.299 87.8794L235.299 73.1702L220.59 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 58.468L220.59 73.1772L235.299 73.1772L235.299 58.468L220.59 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 43.759L220.59 58.4683L235.299 58.4683L235.299 43.759L220.59 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59 29.0569L220.59 43.7661L235.299 43.7661L235.299 29.0569L220.59 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.588 14.3474L220.588 29.0566L235.297 29.0566L235.297 14.3474L220.588 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.588 -0.354722L220.588 14.3545L235.297 14.3545L235.297 -0.354723L220.588 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 367.291L235.291 382L250 382L250 367.291L235.291 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 352.582L235.291 367.291L250 367.291L250 352.582L235.291 352.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 337.88L235.291 352.589L250 352.589L250 337.88L235.291 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 323.17L235.291 337.879L250 337.879L250 323.17L235.291 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 308.468L235.291 323.177L250 323.177L250 308.468L235.291 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 293.759L235.291 308.468L250 308.468L250 293.759L235.291 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 279.057L235.291 293.766L250 293.766L250 279.057L235.291 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 264.347L235.291 279.057L250 279.057L250 264.347L235.291 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 249.645L235.291 264.354L250 264.354L250 249.645L235.291 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 234.936L235.291 249.646L250 249.646L250 234.936L235.291 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 220.234L235.291 234.943L250 234.943L250 220.234L235.291 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 205.525L235.291 220.234L250 220.234L250 205.525L235.291 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 190.823L235.291 205.532L250 205.532L250 190.823L235.291 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 176.114L235.291 190.823L250 190.823L250 176.114L235.291 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 161.411L235.291 176.121L250 176.121L250 161.411L235.291 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 146.702L235.291 161.411L250 161.411L250 146.702L235.291 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 132L235.291 146.709L250 146.709L250 132L235.291 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 117.291L235.291 132L250 132L250 117.291L235.291 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 102.582L235.291 117.291L250 117.291L250 102.582L235.291 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 87.8797L235.291 102.589L250 102.589L250 87.8797L235.291 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 73.1702L235.291 87.8794L250 87.8794L250 73.1702L235.291 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 58.468L235.291 73.1772L250 73.1772L250 58.468L235.291 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 43.759L235.291 58.4683L250 58.4683L250 43.759L235.291 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 29.0569L235.291 43.7661L250 43.7661L250 29.0569L235.291 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 14.3474L235.291 29.0566L250 29.0566L250 14.3474L235.291 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.291 -0.354722L235.291 14.3545L250 14.3545L250 -0.354723L235.291 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 367.291L250 382L264.709 382L264.709 367.291L250 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 352.582L250 367.291L264.709 367.291L264.709 352.582L250 352.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 337.88L250 352.589L264.709 352.589L264.709 337.88L250 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 323.17L250 337.879L264.709 337.879L264.709 323.17L250 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 308.468L250 323.177L264.709 323.177L264.709 308.468L250 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 293.759L250 308.468L264.709 308.468L264.709 293.759L250 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 279.057L250 293.766L264.709 293.766L264.709 279.057L250 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 264.347L250 279.057L264.709 279.057L264.709 264.347L250 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 249.645L250 264.354L264.709 264.354L264.709 249.645L250 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 234.936L250 249.646L264.709 249.646L264.709 234.936L250 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 220.234L250 234.943L264.709 234.943L264.709 220.234L250 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 205.525L250 220.234L264.709 220.234L264.709 205.525L250 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 190.823L250 205.532L264.709 205.532L264.709 190.823L250 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 176.114L250 190.823L264.709 190.823L264.709 176.114L250 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 161.411L250 176.121L264.709 176.121L264.709 161.411L250 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 146.702L250 161.411L264.709 161.411L264.709 146.702L250 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 132L250 146.709L264.709 146.709L264.709 132L250 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 117.291L250 132L264.709 132L264.709 117.291L250 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 102.582L250 117.291L264.709 117.291L264.709 102.582L250 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 87.8797L250 102.589L264.709 102.589L264.709 87.8797L250 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 73.1702L250 87.8794L264.709 87.8794L264.709 73.1702L250 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 58.468L250 73.1772L264.709 73.1772L264.709 58.468L250 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 43.759L250 58.4683L264.709 58.4683L264.709 43.759L250 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 29.0569L250 43.7661L264.709 43.7661L264.709 29.0569L250 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 14.3474L250 29.0566L264.709 29.0566L264.709 14.3474L250 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 -0.354722L250 14.3545L264.709 14.3545L264.709 -0.354723L250 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 367.291L264.709 382L279.418 382L279.418 367.291L264.709 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 352.581L264.709 367.291L279.418 367.291L279.418 352.581L264.709 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 337.879L264.709 352.588L279.418 352.588L279.418 337.879L264.709 337.879Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 323.17L264.709 337.879L279.418 337.879L279.418 323.17L264.709 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 308.468L264.709 323.177L279.418 323.177L279.418 308.468L264.709 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 293.759L264.709 308.468L279.418 308.468L279.418 293.759L264.709 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 279.057L264.709 293.766L279.418 293.766L279.418 279.057L264.709 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 264.347L264.709 279.057L279.418 279.057L279.418 264.347L264.709 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 249.645L264.709 264.354L279.418 264.354L279.418 249.645L264.709 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 234.936L264.709 249.646L279.418 249.646L279.418 234.936L264.709 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 220.234L264.709 234.943L279.418 234.943L279.418 220.234L264.709 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 205.525L264.709 220.234L279.418 220.234L279.418 205.525L264.709 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 190.823L264.709 205.532L279.418 205.532L279.418 190.823L264.709 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 176.114L264.709 190.823L279.418 190.823L279.418 176.114L264.709 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 161.411L264.709 176.121L279.418 176.121L279.418 161.411L264.709 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 146.702L264.709 161.411L279.418 161.411L279.418 146.702L264.709 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 132L264.709 146.709L279.418 146.709L279.418 132L264.709 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 117.291L264.709 132L279.418 132L279.418 117.291L264.709 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 102.582L264.709 117.291L279.418 117.291L279.418 102.582L264.709 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 87.8797L264.709 102.589L279.418 102.589L279.418 87.8797L264.709 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 73.1702L264.709 87.8794L279.418 87.8794L279.418 73.1702L264.709 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 58.468L264.709 73.1772L279.418 73.1772L279.418 58.468L264.709 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 43.759L264.709 58.4683L279.418 58.4683L279.418 43.759L264.709 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 29.0569L264.709 43.7661L279.418 43.7661L279.418 29.0569L264.709 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 14.3474L264.709 29.0566L279.418 29.0566L279.418 14.3474L264.709 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.709 -0.354722L264.709 14.3545L279.418 14.3545L279.418 -0.354723L264.709 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 367.291L279.412 382L294.121 382L294.121 367.291L279.412 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 352.581L279.412 367.291L294.121 367.291L294.121 352.581L279.412 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 337.879L279.412 352.588L294.121 352.588L294.121 337.879L279.412 337.879Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 323.17L279.412 337.879L294.121 337.879L294.121 323.17L279.412 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 308.468L279.412 323.177L294.121 323.177L294.121 308.468L279.412 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 293.759L279.412 308.468L294.121 308.468L294.121 293.759L279.412 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 279.057L279.412 293.766L294.121 293.766L294.121 279.057L279.412 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 264.347L279.412 279.057L294.121 279.057L294.121 264.347L279.412 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 249.645L279.412 264.354L294.121 264.354L294.121 249.645L279.412 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 234.936L279.412 249.646L294.121 249.646L294.121 234.936L279.412 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 220.234L279.412 234.943L294.121 234.943L294.121 220.234L279.412 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 205.525L279.412 220.234L294.121 220.234L294.121 205.525L279.412 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 190.823L279.412 205.532L294.121 205.532L294.121 190.823L279.412 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 176.114L279.412 190.823L294.121 190.823L294.121 176.114L279.412 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 161.411L279.412 176.121L294.121 176.121L294.121 161.411L279.412 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 146.702L279.412 161.411L294.121 161.411L294.121 146.702L279.412 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 132L279.412 146.709L294.121 146.709L294.121 132L279.412 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 117.291L279.412 132L294.121 132L294.121 117.291L279.412 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 102.582L279.412 117.291L294.121 117.291L294.121 102.582L279.412 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 87.8797L279.412 102.589L294.121 102.589L294.121 87.8797L279.412 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 73.1702L279.412 87.8794L294.121 87.8794L294.121 73.1702L279.412 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 58.468L279.412 73.1772L294.121 73.1772L294.121 58.468L279.412 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 43.759L279.412 58.4683L294.121 58.4683L294.121 43.759L279.412 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 29.0569L279.412 43.7661L294.121 43.7661L294.121 29.0569L279.412 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 14.3474L279.412 29.0566L294.121 29.0566L294.121 14.3474L279.412 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.412 -0.354722L279.412 14.3545L294.121 14.3545L294.121 -0.354723L279.412 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 367.291L294.121 382L308.83 382L308.83 367.291L294.121 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 352.581L294.121 367.291L308.83 367.291L308.83 352.581L294.121 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 337.88L294.121 352.589L308.83 352.589L308.83 337.88L294.121 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 323.17L294.121 337.879L308.83 337.879L308.83 323.17L294.121 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 308.468L294.121 323.177L308.83 323.177L308.83 308.468L294.121 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 293.759L294.121 308.468L308.83 308.468L308.83 293.759L294.121 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 279.057L294.121 293.766L308.83 293.766L308.83 279.057L294.121 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 264.347L294.121 279.057L308.83 279.057L308.83 264.347L294.121 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 249.645L294.121 264.354L308.83 264.354L308.83 249.645L294.121 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 234.936L294.121 249.646L308.83 249.646L308.83 234.936L294.121 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 220.234L294.121 234.943L308.83 234.943L308.83 220.234L294.121 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 205.525L294.121 220.234L308.83 220.234L308.83 205.525L294.121 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 190.823L294.121 205.532L308.83 205.532L308.83 190.823L294.121 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 176.114L294.121 190.823L308.83 190.823L308.83 176.114L294.121 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 161.411L294.121 176.121L308.83 176.121L308.83 161.411L294.121 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 146.702L294.121 161.411L308.83 161.411L308.83 146.702L294.121 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 132L294.121 146.709L308.83 146.709L308.83 132L294.121 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 117.291L294.121 132L308.83 132L308.83 117.291L294.121 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 102.582L294.121 117.291L308.83 117.291L308.83 102.582L294.121 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 87.8797L294.121 102.589L308.83 102.589L308.83 87.8797L294.121 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 73.1702L294.121 87.8794L308.83 87.8794L308.83 73.1702L294.121 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 58.468L294.121 73.1772L308.83 73.1772L308.83 58.468L294.121 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 43.759L294.121 58.4683L308.83 58.4683L308.83 43.759L294.121 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 29.0569L294.121 43.7661L308.83 43.7661L308.83 29.0569L294.121 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 14.3474L294.121 29.0566L308.83 29.0566L308.83 14.3474L294.121 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.121 -0.354722L294.121 14.3545L308.83 14.3545L308.83 -0.354723L294.121 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 367.291L308.822 382L323.531 382L323.531 367.291L308.822 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 352.581L308.822 367.291L323.531 367.291L323.531 352.581L308.822 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 337.879L308.822 352.588L323.531 352.588L323.531 337.879L308.822 337.879Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 323.17L308.822 337.879L323.531 337.879L323.531 323.17L308.822 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 308.468L308.822 323.177L323.531 323.177L323.531 308.468L308.822 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 293.759L308.822 308.468L323.531 308.468L323.531 293.759L308.822 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 279.057L308.822 293.766L323.531 293.766L323.531 279.057L308.822 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 264.347L308.822 279.057L323.531 279.057L323.531 264.347L308.822 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 249.645L308.822 264.354L323.531 264.354L323.531 249.645L308.822 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 234.936L308.822 249.646L323.531 249.646L323.531 234.936L308.822 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 220.234L308.822 234.943L323.531 234.943L323.531 220.234L308.822 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 205.525L308.822 220.234L323.531 220.234L323.531 205.525L308.822 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 190.823L308.822 205.532L323.531 205.532L323.531 190.823L308.822 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 176.114L308.822 190.823L323.531 190.823L323.531 176.114L308.822 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 161.411L308.822 176.121L323.531 176.121L323.531 161.411L308.822 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 146.702L308.822 161.411L323.531 161.411L323.531 146.702L308.822 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 132L308.822 146.709L323.531 146.709L323.531 132L308.822 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 117.291L308.822 132L323.531 132L323.531 117.291L308.822 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 102.582L308.822 117.291L323.531 117.291L323.531 102.582L308.822 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 87.8797L308.822 102.589L323.531 102.589L323.531 87.8797L308.822 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 73.1702L308.822 87.8794L323.531 87.8794L323.531 73.1702L308.822 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 58.468L308.822 73.1772L323.531 73.1772L323.531 58.468L308.822 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 43.759L308.822 58.4683L323.531 58.4683L323.531 43.759L308.822 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 29.0569L308.822 43.7661L323.531 43.7661L323.531 29.0569L308.822 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 14.3474L308.822 29.0566L323.531 29.0566L323.531 14.3474L308.822 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.822 -0.354722L308.822 14.3545L323.531 14.3545L323.531 -0.354723L308.822 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 367.291L323.531 382L338.24 382L338.24 367.291L323.531 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 352.581L323.531 367.291L338.24 367.291L338.24 352.581L323.531 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 337.879L323.531 352.588L338.24 352.588L338.24 337.879L323.531 337.879Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 323.17L323.531 337.879L338.24 337.879L338.24 323.17L323.531 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 308.468L323.531 323.177L338.24 323.177L338.24 308.468L323.531 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 293.759L323.531 308.468L338.24 308.468L338.24 293.759L323.531 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 279.057L323.531 293.766L338.24 293.766L338.24 279.057L323.531 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 264.347L323.531 279.057L338.24 279.057L338.24 264.347L323.531 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 249.645L323.531 264.354L338.24 264.354L338.24 249.645L323.531 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 234.936L323.531 249.646L338.24 249.646L338.24 234.936L323.531 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 220.234L323.531 234.943L338.24 234.943L338.24 220.234L323.531 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 205.525L323.531 220.234L338.24 220.234L338.24 205.525L323.531 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 190.823L323.531 205.532L338.24 205.532L338.24 190.823L323.531 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 176.114L323.531 190.823L338.24 190.823L338.24 176.114L323.531 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 161.411L323.531 176.121L338.24 176.121L338.24 161.411L323.531 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 146.702L323.531 161.411L338.24 161.411L338.24 146.702L323.531 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 132L323.531 146.709L338.24 146.709L338.24 132L323.531 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 117.291L323.531 132L338.24 132L338.24 117.291L323.531 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 102.582L323.531 117.291L338.24 117.291L338.24 102.582L323.531 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 87.8797L323.531 102.589L338.24 102.589L338.24 87.8797L323.531 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 73.1702L323.531 87.8794L338.24 87.8794L338.24 73.1702L323.531 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 58.468L323.531 73.1772L338.24 73.1772L338.24 58.468L323.531 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 43.759L323.531 58.4683L338.24 58.4683L338.24 43.759L323.531 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 29.0569L323.531 43.7661L338.24 43.7661L338.24 29.0569L323.531 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 14.3474L323.531 29.0566L338.24 29.0566L338.24 14.3474L323.531 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.531 -0.354722L323.531 14.3545L338.24 14.3545L338.24 -0.354723L323.531 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 367.291L338.234 382L352.944 382L352.944 367.291L338.234 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 352.581L338.234 367.291L352.944 367.291L352.944 352.581L338.234 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 337.88L338.234 352.589L352.944 352.589L352.944 337.88L338.234 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 323.17L338.234 337.879L352.944 337.879L352.944 323.17L338.234 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 308.468L338.234 323.177L352.944 323.177L352.944 308.468L338.234 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 293.759L338.234 308.468L352.944 308.468L352.944 293.759L338.234 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 279.057L338.234 293.766L352.944 293.766L352.944 279.057L338.234 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 264.347L338.234 279.057L352.944 279.057L352.944 264.347L338.234 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 249.645L338.234 264.354L352.944 264.354L352.944 249.645L338.234 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 234.936L338.234 249.646L352.944 249.646L352.944 234.936L338.234 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 220.234L338.234 234.943L352.944 234.943L352.944 220.234L338.234 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 205.525L338.234 220.234L352.944 220.234L352.944 205.525L338.234 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 190.823L338.234 205.532L352.944 205.532L352.944 190.823L338.234 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 176.114L338.234 190.823L352.944 190.823L352.944 176.114L338.234 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 161.411L338.234 176.121L352.944 176.121L352.944 161.411L338.234 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 146.702L338.234 161.411L352.944 161.411L352.944 146.702L338.234 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 132L338.234 146.709L352.944 146.709L352.944 132L338.234 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 117.291L338.234 132L352.944 132L352.944 117.291L338.234 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 102.582L338.234 117.291L352.944 117.291L352.944 102.582L338.234 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 87.8797L338.234 102.589L352.944 102.589L352.944 87.8797L338.234 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 73.1702L338.234 87.8794L352.944 87.8794L352.944 73.1702L338.234 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 58.468L338.234 73.1772L352.944 73.1772L352.944 58.468L338.234 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 43.759L338.234 58.4683L352.944 58.4683L352.944 43.759L338.234 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 29.0569L338.234 43.7661L352.944 43.7661L352.944 29.0569L338.234 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 14.3474L338.234 29.0566L352.944 29.0566L352.944 14.3474L338.234 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.234 -0.354722L338.234 14.3545L352.944 14.3545L352.944 -0.354723L338.234 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 367.291L352.943 382L367.653 382L367.653 367.291L352.943 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 352.581L352.943 367.291L367.653 367.291L367.653 352.581L352.943 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 337.88L352.943 352.589L367.653 352.589L367.653 337.88L352.943 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 323.17L352.943 337.879L367.653 337.879L367.653 323.17L352.943 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 308.468L352.943 323.177L367.653 323.177L367.653 308.468L352.943 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 293.759L352.943 308.468L367.653 308.468L367.653 293.759L352.943 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 279.057L352.943 293.766L367.653 293.766L367.653 279.057L352.943 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 264.347L352.943 279.057L367.653 279.057L367.653 264.347L352.943 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 249.645L352.943 264.354L367.653 264.354L367.653 249.645L352.943 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 234.936L352.943 249.646L367.653 249.646L367.653 234.936L352.943 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 220.234L352.943 234.943L367.653 234.943L367.653 220.234L352.943 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 205.525L352.943 220.234L367.653 220.234L367.653 205.525L352.943 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 190.823L352.943 205.532L367.653 205.532L367.653 190.823L352.943 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 176.114L352.943 190.823L367.653 190.823L367.653 176.114L352.943 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 161.411L352.943 176.121L367.653 176.121L367.653 161.411L352.943 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 146.702L352.943 161.411L367.653 161.411L367.653 146.702L352.943 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 132L352.943 146.709L367.653 146.709L367.653 132L352.943 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 117.291L352.943 132L367.653 132L367.653 117.291L352.943 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 102.582L352.943 117.291L367.653 117.291L367.653 102.582L352.943 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 87.8797L352.943 102.589L367.653 102.589L367.653 87.8797L352.943 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 73.1702L352.943 87.8794L367.653 87.8794L367.653 73.1702L352.943 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 58.468L352.943 73.1772L367.653 73.1772L367.653 58.468L352.943 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 43.759L352.943 58.4683L367.653 58.4683L367.653 43.759L352.943 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 29.0569L352.943 43.7661L367.653 43.7661L367.653 29.0569L352.943 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 14.3474L352.943 29.0566L367.653 29.0566L367.653 14.3474L352.943 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.943 -0.354722L352.943 14.3545L367.653 14.3545L367.653 -0.354723L352.943 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 367.291L367.645 382L382.354 382L382.354 367.291L367.645 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 352.581L367.645 367.291L382.354 367.291L382.354 352.581L367.645 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 337.879L367.645 352.588L382.354 352.588L382.354 337.879L367.645 337.879Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 323.17L367.645 337.879L382.354 337.879L382.354 323.17L367.645 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 308.468L367.645 323.177L382.354 323.177L382.354 308.468L367.645 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 293.759L367.645 308.468L382.354 308.468L382.354 293.759L367.645 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 279.057L367.645 293.766L382.354 293.766L382.354 279.057L367.645 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 264.347L367.645 279.057L382.354 279.057L382.354 264.347L367.645 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 249.645L367.645 264.354L382.354 264.354L382.354 249.645L367.645 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 234.936L367.645 249.646L382.354 249.646L382.354 234.936L367.645 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 220.234L367.645 234.943L382.354 234.943L382.354 220.234L367.645 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 205.525L367.645 220.234L382.354 220.234L382.354 205.525L367.645 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 190.823L367.645 205.532L382.354 205.532L382.354 190.823L367.645 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 176.114L367.645 190.823L382.354 190.823L382.354 176.114L367.645 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 161.411L367.645 176.121L382.354 176.121L382.354 161.411L367.645 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 146.702L367.645 161.411L382.354 161.411L382.354 146.702L367.645 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 132L367.645 146.709L382.354 146.709L382.354 132L367.645 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 117.291L367.645 132L382.354 132L382.354 117.291L367.645 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 102.582L367.645 117.291L382.354 117.291L382.354 102.582L367.645 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 87.8797L367.645 102.589L382.354 102.589L382.354 87.8797L367.645 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 73.1702L367.645 87.8794L382.354 87.8794L382.354 73.1702L367.645 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 58.468L367.645 73.1772L382.354 73.1772L382.354 58.468L367.645 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 43.759L367.645 58.4683L382.354 58.4683L382.354 43.759L367.645 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 29.0569L367.645 43.7661L382.354 43.7661L382.354 29.0569L367.645 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 14.3474L367.645 29.0566L382.354 29.0566L382.354 14.3474L367.645 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.645 -0.354722L367.645 14.3545L382.354 14.3545L382.354 -0.354723L367.645 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 367.291L382.355 382L397.065 382L397.065 367.291L382.355 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 352.581L382.355 367.291L397.065 367.291L397.065 352.581L382.355 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 337.88L382.355 352.589L397.065 352.589L397.065 337.88L382.355 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 323.17L382.355 337.879L397.065 337.879L397.065 323.17L382.355 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 308.468L382.355 323.177L397.065 323.177L397.065 308.468L382.355 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 293.759L382.355 308.468L397.065 308.468L397.065 293.759L382.355 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 279.057L382.355 293.766L397.065 293.766L397.065 279.057L382.355 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 264.347L382.355 279.057L397.065 279.057L397.065 264.347L382.355 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 249.645L382.355 264.354L397.065 264.354L397.065 249.645L382.355 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 234.936L382.355 249.646L397.065 249.646L397.065 234.936L382.355 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 220.234L382.355 234.943L397.065 234.943L397.065 220.234L382.355 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 205.525L382.355 220.234L397.065 220.234L397.065 205.525L382.355 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 190.823L382.355 205.532L397.065 205.532L397.065 190.823L382.355 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 176.114L382.355 190.823L397.065 190.823L397.065 176.114L382.355 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 161.411L382.355 176.121L397.065 176.121L397.065 161.411L382.355 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 146.702L382.355 161.411L397.065 161.411L397.065 146.702L382.355 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 132L382.355 146.709L397.065 146.709L397.065 132L382.355 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 117.291L382.355 132L397.065 132L397.065 117.291L382.355 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 102.582L382.355 117.291L397.065 117.291L397.065 102.582L382.355 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 87.8797L382.355 102.589L397.065 102.589L397.065 87.8797L382.355 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 73.1702L382.355 87.8794L397.065 87.8794L397.065 73.1702L382.355 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 58.468L382.355 73.1772L397.065 73.1772L397.065 58.468L382.355 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 43.759L382.355 58.4683L397.065 58.4683L397.065 43.759L382.355 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 29.0569L382.355 43.7661L397.065 43.7661L397.065 29.0569L382.355 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 14.3474L382.355 29.0566L397.065 29.0566L397.065 14.3474L382.355 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.355 -0.354722L382.355 14.3545L397.065 14.3545L397.065 -0.354723L382.355 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 367.291L397.057 382L411.766 382L411.766 367.291L397.057 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 352.581L397.057 367.291L411.766 367.291L411.766 352.581L397.057 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 337.88L397.057 352.589L411.766 352.589L411.766 337.88L397.057 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 323.17L397.057 337.879L411.766 337.879L411.766 323.17L397.057 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 308.468L397.057 323.177L411.766 323.177L411.766 308.468L397.057 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 293.759L397.057 308.468L411.766 308.468L411.766 293.759L397.057 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 279.057L397.057 293.766L411.766 293.766L411.766 279.057L397.057 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 264.347L397.057 279.057L411.766 279.057L411.766 264.347L397.057 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 249.645L397.057 264.354L411.766 264.354L411.766 249.645L397.057 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 234.936L397.057 249.646L411.766 249.646L411.766 234.936L397.057 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 220.234L397.057 234.943L411.766 234.943L411.766 220.234L397.057 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 205.525L397.057 220.234L411.766 220.234L411.766 205.525L397.057 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 190.823L397.057 205.532L411.766 205.532L411.766 190.823L397.057 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 176.114L397.057 190.823L411.766 190.823L411.766 176.114L397.057 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 161.411L397.057 176.121L411.766 176.121L411.766 161.411L397.057 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 146.702L397.057 161.411L411.766 161.411L411.766 146.702L397.057 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 132L397.057 146.709L411.766 146.709L411.766 132L397.057 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 117.291L397.057 132L411.766 132L411.766 117.291L397.057 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 102.582L397.057 117.291L411.766 117.291L411.766 102.582L397.057 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 87.8797L397.057 102.589L411.766 102.589L411.766 87.8797L397.057 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 73.1702L397.057 87.8794L411.766 87.8794L411.766 73.1702L397.057 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 58.468L397.057 73.1772L411.766 73.1772L411.766 58.468L397.057 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 43.759L397.057 58.4683L411.766 58.4683L411.766 43.759L397.057 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 29.0569L397.057 43.7661L411.766 43.7661L411.766 29.0569L397.057 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 14.3474L397.057 29.0566L411.766 29.0566L411.766 14.3474L397.057 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 -0.354722L397.057 14.3545L411.766 14.3545L411.766 -0.354723L397.057 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 367.291L411.766 382L426.475 382L426.475 367.291L411.766 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 352.581L411.766 367.291L426.475 367.291L426.475 352.581L411.766 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 337.879L411.766 352.588L426.475 352.588L426.475 337.879L411.766 337.879Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 323.17L411.766 337.879L426.475 337.879L426.475 323.17L411.766 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 308.468L411.766 323.177L426.475 323.177L426.475 308.468L411.766 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 293.759L411.766 308.468L426.475 308.468L426.475 293.759L411.766 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 279.057L411.766 293.766L426.475 293.766L426.475 279.057L411.766 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 264.347L411.766 279.057L426.475 279.057L426.475 264.347L411.766 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 249.645L411.766 264.354L426.475 264.354L426.475 249.645L411.766 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 234.936L411.766 249.646L426.475 249.646L426.475 234.936L411.766 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 220.234L411.766 234.943L426.475 234.943L426.475 220.234L411.766 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 205.525L411.766 220.234L426.475 220.234L426.475 205.525L411.766 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 190.823L411.766 205.532L426.475 205.532L426.475 190.823L411.766 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 176.114L411.766 190.823L426.475 190.823L426.475 176.114L411.766 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 161.411L411.766 176.121L426.475 176.121L426.475 161.411L411.766 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 146.702L411.766 161.411L426.475 161.411L426.475 146.702L411.766 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 132L411.766 146.709L426.475 146.709L426.475 132L411.766 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 117.291L411.766 132L426.475 132L426.475 117.291L411.766 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 102.582L411.766 117.291L426.475 117.291L426.475 102.582L411.766 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 87.8797L411.766 102.589L426.475 102.589L426.475 87.8797L411.766 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 73.1702L411.766 87.8794L426.475 87.8794L426.475 73.1702L411.766 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 58.468L411.766 73.1772L426.475 73.1772L426.475 58.468L411.766 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 43.759L411.766 58.4683L426.475 58.4683L426.475 43.759L411.766 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 29.0569L411.766 43.7661L426.475 43.7661L426.475 29.0569L411.766 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 14.3474L411.766 29.0566L426.475 29.0566L426.475 14.3474L411.766 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 -0.354722L411.766 14.3545L426.475 14.3545L426.475 -0.354723L411.766 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 367.291L426.469 382L441.178 382L441.178 367.291L426.469 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 352.581L426.469 367.291L441.178 367.291L441.178 352.581L426.469 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 337.88L426.469 352.589L441.178 352.589L441.178 337.88L426.469 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 323.17L426.469 337.879L441.178 337.879L441.178 323.17L426.469 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 308.468L426.469 323.177L441.178 323.177L441.178 308.468L426.469 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 293.759L426.469 308.468L441.178 308.468L441.178 293.759L426.469 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 279.057L426.469 293.766L441.178 293.766L441.178 279.057L426.469 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 264.347L426.469 279.057L441.178 279.057L441.178 264.347L426.469 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 249.645L426.469 264.354L441.178 264.354L441.178 249.645L426.469 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 234.936L426.469 249.646L441.178 249.646L441.178 234.936L426.469 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 220.234L426.469 234.943L441.178 234.943L441.178 220.234L426.469 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 205.525L426.469 220.234L441.178 220.234L441.178 205.525L426.469 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 190.823L426.469 205.532L441.178 205.532L441.178 190.823L426.469 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 176.114L426.469 190.823L441.178 190.823L441.178 176.114L426.469 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 161.411L426.469 176.121L441.178 176.121L441.178 161.411L426.469 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 146.702L426.469 161.411L441.178 161.411L441.178 146.702L426.469 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 132L426.469 146.709L441.178 146.709L441.178 132L426.469 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 117.291L426.469 132L441.178 132L441.178 117.291L426.469 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 102.582L426.469 117.291L441.178 117.291L441.178 102.582L426.469 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 87.8797L426.469 102.589L441.178 102.589L441.178 87.8797L426.469 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 73.1702L426.469 87.8794L441.178 87.8794L441.178 73.1702L426.469 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 58.468L426.469 73.1772L441.178 73.1772L441.178 58.468L426.469 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 43.759L426.469 58.4683L441.178 58.4683L441.178 43.759L426.469 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 29.0569L426.469 43.7661L441.178 43.7661L441.178 29.0569L426.469 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 14.3474L426.469 29.0566L441.178 29.0566L441.178 14.3474L426.469 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.469 -0.354722L426.469 14.3545L441.178 14.3545L441.178 -0.354723L426.469 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 367.291L441.178 382L455.887 382L455.887 367.291L441.178 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 352.581L441.178 367.291L455.887 367.291L455.887 352.581L441.178 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 337.879L441.178 352.588L455.887 352.588L455.887 337.879L441.178 337.879Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 323.17L441.178 337.879L455.887 337.879L455.887 323.17L441.178 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 308.468L441.178 323.177L455.887 323.177L455.887 308.468L441.178 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 293.759L441.178 308.468L455.887 308.468L455.887 293.759L441.178 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 279.057L441.178 293.766L455.887 293.766L455.887 279.057L441.178 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 264.347L441.178 279.057L455.887 279.057L455.887 264.347L441.178 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 249.645L441.178 264.354L455.887 264.354L455.887 249.645L441.178 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 234.936L441.178 249.646L455.887 249.646L455.887 234.936L441.178 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 220.234L441.178 234.943L455.887 234.943L455.887 220.234L441.178 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 205.525L441.178 220.234L455.887 220.234L455.887 205.525L441.178 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 190.823L441.178 205.532L455.887 205.532L455.887 190.823L441.178 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 176.114L441.178 190.823L455.887 190.823L455.887 176.114L441.178 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 161.411L441.178 176.121L455.887 176.121L455.887 161.411L441.178 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 146.702L441.178 161.411L455.887 161.411L455.887 146.702L441.178 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 132L441.178 146.709L455.887 146.709L455.887 132L441.178 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 117.291L441.178 132L455.887 132L455.887 117.291L441.178 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 102.582L441.178 117.291L455.887 117.291L455.887 102.582L441.178 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 87.8797L441.178 102.589L455.887 102.589L455.887 87.8797L441.178 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 73.1702L441.178 87.8794L455.887 87.8794L455.887 73.1702L441.178 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 58.468L441.178 73.1772L455.887 73.1772L455.887 58.468L441.178 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 43.759L441.178 58.4683L455.887 58.4683L455.887 43.759L441.178 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 29.0569L441.178 43.7661L455.887 43.7661L455.887 29.0569L441.178 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 14.3474L441.178 29.0566L455.887 29.0566L455.887 14.3474L441.178 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.178 -0.354722L441.178 14.3545L455.887 14.3545L455.887 -0.354723L441.178 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 367.291L455.879 382L470.588 382L470.588 367.291L455.879 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 352.581L455.879 367.291L470.588 367.291L470.588 352.581L455.879 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 337.879L455.879 352.588L470.588 352.588L470.588 337.879L455.879 337.879Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 323.17L455.879 337.879L470.588 337.879L470.588 323.17L455.879 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 308.468L455.879 323.177L470.588 323.177L470.588 308.468L455.879 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 293.759L455.879 308.468L470.588 308.468L470.588 293.759L455.879 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 279.057L455.879 293.766L470.588 293.766L470.588 279.057L455.879 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 264.347L455.879 279.057L470.588 279.057L470.588 264.347L455.879 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 249.645L455.879 264.354L470.588 264.354L470.588 249.645L455.879 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 234.936L455.879 249.646L470.588 249.646L470.588 234.936L455.879 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 220.234L455.879 234.943L470.588 234.943L470.588 220.234L455.879 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 205.525L455.879 220.234L470.588 220.234L470.588 205.525L455.879 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 190.823L455.879 205.532L470.588 205.532L470.588 190.823L455.879 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 176.114L455.879 190.823L470.588 190.823L470.588 176.114L455.879 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 161.411L455.879 176.121L470.588 176.121L470.588 161.411L455.879 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 146.702L455.879 161.411L470.588 161.411L470.588 146.702L455.879 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 132L455.879 146.709L470.588 146.709L470.588 132L455.879 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 117.291L455.879 132L470.588 132L470.588 117.291L455.879 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 102.582L455.879 117.291L470.588 117.291L470.588 102.582L455.879 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 87.8797L455.879 102.589L470.588 102.589L470.588 87.8797L455.879 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 73.1702L455.879 87.8794L470.588 87.8794L470.588 73.1702L455.879 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 58.468L455.879 73.1772L470.588 73.1772L470.588 58.468L455.879 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 43.759L455.879 58.4683L470.588 58.4683L470.588 43.759L455.879 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 29.0569L455.879 43.7661L470.588 43.7661L470.588 29.0569L455.879 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 14.3474L455.879 29.0566L470.588 29.0566L470.588 14.3474L455.879 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.879 -0.354722L455.879 14.3545L470.588 14.3545L470.588 -0.354723L455.879 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 367.291L470.588 382L485.297 382L485.297 367.291L470.588 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 352.581L470.588 367.291L485.297 367.291L485.297 352.581L470.588 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 337.88L470.588 352.589L485.297 352.589L485.297 337.88L470.588 337.88Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 323.17L470.588 337.879L485.297 337.879L485.297 323.17L470.588 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 308.468L470.588 323.177L485.297 323.177L485.297 308.468L470.588 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 293.759L470.588 308.468L485.297 308.468L485.297 293.759L470.588 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 279.057L470.588 293.766L485.297 293.766L485.297 279.057L470.588 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 264.347L470.588 279.057L485.297 279.057L485.297 264.347L470.588 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 249.645L470.588 264.354L485.297 264.354L485.297 249.645L470.588 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 234.936L470.588 249.646L485.297 249.646L485.297 234.936L470.588 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 220.234L470.588 234.943L485.297 234.943L485.297 220.234L470.588 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 205.525L470.588 220.234L485.297 220.234L485.297 205.525L470.588 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 190.823L470.588 205.532L485.297 205.532L485.297 190.823L470.588 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 176.114L470.588 190.823L485.297 190.823L485.297 176.114L470.588 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 161.411L470.588 176.121L485.297 176.121L485.297 161.411L470.588 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 146.702L470.588 161.411L485.297 161.411L485.297 146.702L470.588 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 132L470.588 146.709L485.297 146.709L485.297 132L470.588 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 117.291L470.588 132L485.297 132L485.297 117.291L470.588 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 102.582L470.588 117.291L485.297 117.291L485.297 102.582L470.588 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 87.8797L470.588 102.589L485.297 102.589L485.297 87.8797L470.588 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 73.1702L470.588 87.8794L485.297 87.8794L485.297 73.1702L470.588 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 58.468L470.588 73.1772L485.297 73.1772L485.297 58.468L470.588 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 43.759L470.588 58.4683L485.297 58.4683L485.297 43.759L470.588 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 29.0569L470.588 43.7661L485.297 43.7661L485.297 29.0569L470.588 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 14.3474L470.588 29.0566L485.297 29.0566L485.297 14.3474L470.588 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.588 -0.354722L470.588 14.3545L485.297 14.3545L485.297 -0.354723L470.588 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 367.291L485.291 382L500 382L500 367.291L485.291 367.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 352.581L485.291 367.291L500 367.291L500 352.581L485.291 352.581Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 337.879L485.291 352.588L500 352.588L500 337.879L485.291 337.879Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 323.17L485.291 337.879L500 337.879L500 323.17L485.291 323.17Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 308.468L485.291 323.177L500 323.177L500 308.468L485.291 308.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 293.759L485.291 308.468L500 308.468L500 293.759L485.291 293.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 279.057L485.291 293.766L500 293.766L500 279.057L485.291 279.057Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 264.347L485.291 279.057L500 279.057L500 264.347L485.291 264.347Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 249.645L485.291 264.354L500 264.354L500 249.645L485.291 249.645Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 234.936L485.291 249.646L500 249.646L500 234.936L485.291 234.936Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 220.234L485.291 234.943L500 234.943L500 220.234L485.291 220.234Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 205.525L485.291 220.234L500 220.234L500 205.525L485.291 205.525Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 190.823L485.291 205.532L500 205.532L500 190.823L485.291 190.823Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 176.114L485.291 190.823L500 190.823L500 176.114L485.291 176.114Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 161.411L485.291 176.121L500 176.121L500 161.411L485.291 161.411Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 146.702L485.291 161.411L500 161.411L500 146.702L485.291 146.702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 132L485.291 146.709L500 146.709L500 132L485.291 132Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 117.291L485.291 132L500 132L500 117.291L485.291 117.291Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 102.582L485.291 117.291L500 117.291L500 102.582L485.291 102.582Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 87.8797L485.291 102.589L500 102.589L500 87.8797L485.291 87.8797Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 73.1702L485.291 87.8794L500 87.8794L500 73.1702L485.291 73.1702Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 58.468L485.291 73.1772L500 73.1772L500 58.468L485.291 58.468Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 43.759L485.291 58.4683L500 58.4683L500 43.759L485.291 43.759Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 29.0569L485.291 43.7661L500 43.7661L500 29.0569L485.291 29.0569Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 14.3474L485.291 29.0566L500 29.0566L500 14.3474L485.291 14.3474Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.291 -0.354722L485.291 14.3545L500 14.3545L500 -0.354723L485.291 -0.354722Z",
    stroke: "#150D21",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine1);
export default __webpack_public_path__ + "static/media/line-1.1fb3e4d3f4f1c5280fb404437619ce34.svg";
export { ForwardRef as ReactComponent };